/**
 * Change styles to header search.
 */
function initHeaderSearch() {
    const searchButton = document.querySelector('#searchButton');
    const searchInput = document.querySelector('#searchTermInput');

    function searchPopup(event) {
        event.preventDefault();
        const searchTerm = searchInput.value;
        // Encode the search term for URL
        const encodedSearchTerm = encodeURIComponent(searchTerm);
        // Construct the new URL with the search term
        const newUrl = `${searchButton.href}?q=${encodedSearchTerm}`.replace(/\/\?/, "?");
        // Update the href attribute of the link
        searchButton.href = newUrl;
        window.location.href = newUrl;
    }

    if (searchButton && searchInput) {
        searchButton.addEventListener('click', (e) => {
            searchPopup(e);
        });

        searchInput.addEventListener('keypress', (e) => {
            if (e.key === "Enter") {
                searchPopup(e);
            }
        });
    }
}
initHeaderSearch();
export default initHeaderSearch;